import styled from 'styled-components';
import { Form } from '@bynder/design-system';

export const SizeFormRow = styled(Form.Row)`
    grid-template-columns: minmax(10px, 1fr) 24px minmax(10px, 1fr);
    align-items: center;
`;
